import { PropsWithChildren } from "react";

import { Box, xcss } from "@atlaskit/primitives";
import { JiraBackground } from "@atlassian/product-wireframes";

import { Modal } from "@/components/signup/layouts/modal";
import { LayoutVersion } from "@/components/signup/layouts/product-overlay-template";

type JiraOverlayProps = PropsWithChildren;

export const JiraOverlay = ({ children }: JiraOverlayProps) => (
    <JiraBackground>
        <Modal size="lg" showBrandFooter={false} version={LayoutVersion.V2}>
            <Box xcss={wrapper}>{children}</Box>
        </Modal>
    </JiraBackground>
);

const wrapper = xcss({
    width: "100%",
    maxWidth: "1140px",
    height: "640px",
    overflow: "hidden",
    backgroundColor: "elevation.surface.overlay"
});
